import edit from '../../asset/images/icons/edit.svg';
import deleteIcon from '../../asset/images/icons/delete.svg';
import link from '../../asset/images/icons/create-link.svg';
import calendar from '../../asset/images/icons/es_calendar.svg';

export const more = [
    {
        title: 'Edit',
        icon: edit,
    },
    {
        title: 'Delete',
        icon: deleteIcon,
    },
    {
        title: 'Link',
        icon: link,
    },
];

export const contest_more = [
    {
        title: 'Edit',
        id: 'edit',
        icon: edit,
    },
    {
        title: 'Delete',
        id: 'delete',
        icon: deleteIcon,
    },
    {
        title: 'Link',
        id: 'link',
        icon: link,
    },
];

export const filter_more = [
    {
        title: 'Month',
        icon: calendar,
    },
    {
        title: 'Week',
        icon: calendar,
    },
];

export type TMoreMenuItem = {
    title: string;
    id: string;
    icon?: any;
};

export const jury_duty_menu = [
    { title: 'Go To Contest', id: 'go_to_contest' },
    {
        title: 'Vote',
        id: 'vote',
    },
];

export const playlist_menu = [
    {
        title: 'Create New Playlist',
        id: 'new_playlist',
        icon: deleteIcon,
    },
    {
        title: 'Add To Playlist',
        id: 'edit_playlist',
        icon: deleteIcon,
    },
];
export const project_menu = [
    {
        title: 'View Project',
        id: 'view',
        icon: edit,
    },
    {
        title: 'Edit Project',
        id: 'edit',
        icon: edit,
    },
    {
        title: 'Publish Project',
        id: 'publish',
        icon: deleteIcon,
    },
    {
        title: 'Unpublish Project',
        id: 'unpublish',
        icon: deleteIcon,
    },
    {
        title: 'Delete Project',
        id: 'delete',
        icon: deleteIcon,
    },
    {
        title: 'Copy Project Link',
        id: 'copy',
        icon: deleteIcon,
    },
    {
        title: 'Download Project',
        id: 'download',
        icon: deleteIcon,
    },
];

export const profile_menu = [
    {
        title: 'Copy Profile Link',
        id: 'copy',
        icon: edit,
        isAdminRender: false,
    },
    {
        title: 'Social Link [Beta]',
        id: 'create',
        icon: edit,
        isAdminRender: true,
    },
    {
        title: 'Show QR Code [Beta]',
        id: 'qr',
        icon: deleteIcon,
        isAdminRender: true,
    },
    {
        title: 'Create New Company',
        id: 'company',
        icon: edit,
        isAdminRender: false,
    },
];

export const profile_menu_non_admin = [
    {
        title: 'Copy Profile Link',
        id: 'copy',
        icon: edit,
        isAdminRender: false,
    },
    {
        title: 'Show QR Code [Beta]',
        id: 'qr',
        icon: deleteIcon,
        isAdminRender: true,
    },
];
